import { TAsyncStatusContainerProps } from 'affiny-core/modules/asynchronousState/containers/asyncStatusContainerFactory';
import { ElementType, ReactNode } from 'react';

export enum HTTP_STATUS {
  TOO_MANY_REDIRECTS = 310,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  NOT_ACCEPTABLE = 406,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  LOCKED = 423,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY_OR_GATEWAY_TIMEOUT = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
  HTTP_VERSION_NOT_SUPPORTED = 505,
}

export interface IAsyncStatusHandlerProps extends TAsyncStatusContainerProps {
  breakers?: Partial<Record<HTTP_STATUS, ReactNode>>;
  LoaderComponent?: ElementType;
}
